import { getLoginUrl, getLogoutUrl } from '@/utils/sso';
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import CryptoJS from 'crypto-js';
import Cookie from 'js-cookie';
import axios from 'axios';
import { throttle } from '@/utils/throttle';

const AuthContext = createContext();



const decodeUser = (encoded) => {
  try {
    const binary = atob(encoded);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    const decoded = new TextDecoder().decode(bytes);

    if (decoded.startsWith("SALT")) {
      return JSON.parse(decoded.slice(4));
    }
    return null;
  } catch {
    return null;
  }
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const cookieUser = Cookie.get('sso_user_info');

        const checkLogin = useCallback(async () => {
          try {
            
            if(!Cookie.get('checklogin')&&!cookieUser){
              const storedUser = localStorage.getItem("sso_user");
              let userData = storedUser ? JSON.parse(storedUser) : null;
        
              const res = await axios.post('/checklogin', { userData });

              if (res.data?.user) {
                setUser(res.data.user);
                localStorage.setItem("sso_user", JSON.stringify(res.data.user));
              } else {
                setUser(null);
              }
              Cookie.set('checklogin', true, { expires: new Date(Date.now() + 1000 * 60 * 60) });
            }
          } catch (err) {
            console.error("checklogin error", err);
            setUser(null);
          } finally {
            setLoading(false);
          }
        }, []);

    useEffect(() => {
      
      setLoading(true);
      try{
          if (cookieUser) {
            const parsed = decodeUser(cookieUser);
            setUser(parsed);
            localStorage.setItem("sso_user", JSON.stringify(parsed));
          } 
          if(loading) setLoading(false);
        } catch (err) {
          console.error("user login error", err);
          setUser(null);
        }

      
        window.addEventListener('scroll', throttle(checkLogin, 2000));
        return () => {
          window.removeEventListener('scroll', throttle(checkLogin, 2000));
        }
      
    }, []);
    
  const logout = () => {
    localStorage.removeItem("sso_user");
    const logoutUrl = getLogoutUrl(window.location.href);
    if (logoutUrl) {
      window.location.href = logoutUrl;
    }
  };

  const login = () => {
    const loginUrl = getLoginUrl(window.location.href);
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  };

  return (
    <AuthContext.Provider value={{ user, logout, login, isAuthenticated: !!user, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
